<div>
<nav mat-tab-nav-bar class="ao-tabs">
  <a mat-tab-link
     *ngFor="let link of navLinks"
     [routerLink]="[{ outlets: { sub: [link.path] } }]"
     routerLinkActive #rla="routerLinkActive"
     [active]="rla.isActive">
    {{tabLabel(link)}}
  </a>
</nav>

<router-outlet name="sub"></router-outlet>